import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { GOOGLE_APP_VERIFICATION_DOC } from 'constants/misc';
import { openNewTab } from 'utils/misc';


class GoogleAppVerificationDialog extends React.PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleSuccess: PropTypes.func.isRequired,
  };

  handleCancel = () => {
    openNewTab(GOOGLE_APP_VERIFICATION_DOC);
  }

  render() {
    const { isOpen, handleClose, handleSuccess } = this.props;
    return (
      <div>
        <Dialog
          open={isOpen}
          onBackdropClick={handleClose}
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Did you add PR Volt app as a verified app?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCancel} color="primary">
              Not Yet, Show me how
            </Button>
            <Button onClick={handleSuccess} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default GoogleAppVerificationDialog;
